import SpeakingTypes from "./Types";

const INITIAL_STATE = {
  Data: [],
  IsLoading: true,
  HasError: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case SpeakingTypes.SET_SPEAKING_LOADING:
      return { ...state, IsLoading: true, HasError: false };
    case SpeakingTypes.SET_SPEAKING_SUCCESS:
      return { Data: action.payload, IsLoading: false, HasError: false };
    case SpeakingTypes.SET_SPEAKING_FAILURE:
      return { ...state, IsLoading: false, HasError: true };
    default: return state;
  }
}